module.exports = __webpack_public_path__ + "img/closeSlideDown.917ae4cd.svg";